import React, { useState, useEffect } from 'react';
import { LiveKitRoom, VideoConference } from '@livekit/components-react';
import '@livekit/components-styles';
import { livekitService } from '../../services/livekitService';
import './CallView.css';

const CallView = ({ onEndCall, currentUser, roomId, roomName = 'general' }) => {

  const [token, setToken] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const getToken = async () => {
      if (!currentUser) {
        setError('Пользователь не авторизован');
        setIsLoading(false);
        return;
      }

      try {
        setIsLoading(true);
        setError('');

        const identity = currentUser.username || currentUser.email || currentUser.firstName || 'user';
        
        //console.log('Getting token for:', { identity, roomId });
        const tokenData = await livekitService.getToken(identity, roomId);
        setToken(tokenData);
      } catch (err) {
        console.error('Ошибка при получении токена:', err);
        setError('Не удалось подключиться к звонку. Проверьте соединение.');
      } finally {
        setIsLoading(false);
      }
    };

    getToken();
  }, [currentUser, roomId]);

  

  const handleDisconnected = () => {
    onEndCall();
  };

  const handleError = (error) => {
    console.error('Ошибка LiveKit:', error);
    setError('Ошибка подключения к звонку');
  };

 

  if (isLoading) {
    return (
      <div className="flex flex-col h-full items-center justify-center bg-[#2f3136] text-white">
        <div className="w-12 h-12 border-4 border-[#5865F2] border-t-transparent rounded-full animate-spin mb-4"></div>
        <div className="text-lg">Подключение к звонку...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex flex-col h-full items-center justify-center bg-[#2f3136] text-white">
        <div className="text-red-400 text-lg mb-4">{error}</div>
        <button 
          onClick={onEndCall}
          className="bg-[#ed4245] hover:bg-[#c03537] text-white px-6 py-2 rounded transition"
        >
          Вернуться в чат
        </button>
      </div>
    );
  }

  if (!token) {
    return (
      <div className="flex flex-col h-full items-center justify-center bg-[#2f3136] text-white">
        <div className="text-lg">Ошибка: токен не получен</div>
        <button 
          onClick={onEndCall}
          className="bg-[#ed4245] hover:bg-[#c03537] text-white px-6 py-2 rounded mt-4 transition"
        >
          Вернуться в чат
        </button>
      </div>
    );
  }

  return (
    <div className="flex flex-col h-full bg-[#2f3136] text-white">
      {/* Call Header - высота 70px, с кнопкой завершения звонка */}
      <div className="call-header">
        <div className="flex items-center gap-2">
          <span className="text-lg font-semibold">Звонок</span>
          <span className="text-sm text-gray-400"> {roomName}</span>
        </div>
        <button
          onClick={onEndCall}
          className="call-header-end-button"
          title="Завершить звонок"
        >
          <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
            <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.740 4.435a1 1 0 01-.540 1.060l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.540l4.435.740a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.820 18 2 12.180 2 5V3z" />
          </svg>
        </button>
      </div>
      
      <div className="call-container">
        <LiveKitRoom
          serverUrl={livekitService.getServerUrl()}
          token={token}
          connect={true}
          onDisconnected={handleDisconnected}
          onError={handleError}
          className="h-full w-full"
          
          
        >
          <VideoConference />
        </LiveKitRoom>
      </div>
    </div>
  );
};

export default CallView;